import arrow from "../assets/icons/goBackArrow.svg";

const Back = () => {
    const goBack = () => {
        window.history.back();
   }
    return (
      <div onClick={goBack} className="cursor-pointer w-fit">
       <img src={arrow} alt="" className="h-7"/>
      </div>
    );
}
 
export default Back;